/* unplugin-vue-components disabled */import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-75c1ce57"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "errPage-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "text-jumbo text-ginormous"
}, " 401错误! ", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "您没有访问权限！", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "对不起，您没有访问权限，请不要进行非法操作！您可以返回主页面", -1));
const _hoisted_5 = {
  class: "list-unstyled"
};
const _hoisted_6 = {
  class: "link-type"
};
const _hoisted_7 = ["src"];
import errImage from "@/assets/401_images/401.gif";
export default {
  __name: '401',
  setup(__props) {
    let {
      proxy
    } = getCurrentInstance();
    const errGif = ref(errImage + "?" + +new Date());
    function back() {
      if (proxy.$route.query.noGoBack) {
        proxy.$router.push({
          path: "/"
        });
      } else {
        proxy.$router.go(-1);
      }
    }
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_button, {
        icon: "arrow-left",
        class: "pan-back-btn",
        onClick: back
      }, {
        default: _withCtx(() => [_createTextVNode(" 返回 ")]),
        _: 1
      }), _createVNode(_component_el_row, null, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_hoisted_2, _hoisted_3, _hoisted_4, _createElementVNode("ul", _hoisted_5, [_createElementVNode("li", _hoisted_6, [_createVNode(_component_router_link, {
            to: "/"
          }, {
            default: _withCtx(() => [_createTextVNode(" 回首页 ")]),
            _: 1
          })])])]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 12
        }, {
          default: _withCtx(() => [_createElementVNode("img", {
            src: _unref(errGif),
            width: "313",
            height: "428",
            alt: "Girl has dropped her ice cream."
          }, null, 8, _hoisted_7)]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
};